import { render, staticRenderFns } from "./EmptyPage.vue?vue&type=template&id=ef8828f6&scoped=true&"
import script from "./EmptyPage.vue?vue&type=script&lang=js&"
export * from "./EmptyPage.vue?vue&type=script&lang=js&"
import style0 from "./EmptyPage.vue?vue&type=style&index=0&id=ef8828f6&prod&lang=scss&scoped=true&"
import style1 from "./EmptyPage.vue?vue&type=style&index=1&id=ef8828f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8828f6",
  null
  
)

export default component.exports